import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ProfileItem = ({
  profile: {
    user: { _id, name, email, avatar },
    status,
    company,
    location,
    skills,
    social
  }
}) => {
  return (
    <Fragment>
      <div className="profile-item-card card my-3">
        <div className="card-body py-2">
          <div className="d-flex my-2">
            <div className="">
              <img
                src={avatar}
                className="profile-pic"
                // style={{
                //   height: '80px',
                //   width: '80px',
                //   border: '3px solid #ddd'
                // }}
                alt="User's profile picture"
              />
            </div>

            <div className="profile-info">
              <h6 className="name">{name}</h6>
              <span className="text-muted username">{email}</span>
              <div className="social">
                {social && social.facebook && (
                  <a
                    href={social.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    <i className="fab fa-facebook-square facebook"></i>
                  </a>
                )}
                {social && social.twitter && (
                  <a
                    href={social.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    <i className="fab fa-twitter twitter"></i>
                  </a>
                )}
                {social && social.instagram && (
                  <a
                    href={social.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    <i className="fab fa-instagram instagram"></i>
                  </a>
                )}
                {social && social.linkedin && (
                  <a
                    href={social.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    <i className="fab fa-linkedin linkedin"></i>
                  </a>
                )}
              </div>
            </div>
            <Link to={`/profile/${_id}`} className="btn profile-item-btn">
              View
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

ProfileItem.propTypes = {
  profile: PropTypes.object.isRequired
};

export default ProfileItem;
